import { ArrowUpDropCircleOutlineIcon } from './ArrowUpDropCircleOutlineIcon';

/**
 * author: Austin Andrews
 * id 42277E7D-D87A-4DE9-982B-37E6A8AE4E70
 * name arrow-up-drop-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-drop-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopDropCircleOutlineIcon = ArrowUpDropCircleOutlineIcon;
export default ArrowTopDropCircleOutlineIcon